import { TransformModeAuto } from "./TransformModeAuto.js";
import { TransformModeInject } from "./TransformModeInject.js";
import { TransformModePerspective } from "./TransformModePerspective.js";
import { TransformModeRectangle } from "./TransformModeRectangle.js";

export class TransformMode {
    public static Auto = new TransformModeAuto();
    public static Inject = new TransformModeInject();
    public static Perspective = new TransformModePerspective();
    public static Rectangle = new TransformModeRectangle();
}